import * as React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import LinearProgress from '@material-ui/core/LinearProgress';
import './loading.css';
import {Component} from "react";


class Loading1 extends Component {
    constructor(props) {
        super(props);
        this.timeOut = 0;
        this.state = {};
    }

    componentDidMount() {
        this.timeOut = setTimeout(() => {
            this.setState({show: true})
        }, 1000)
    }

    componentWillUnmount() {
        clearTimeout(this.timeOut)
    }

    render() {
        if (this.state.show) {
            return (
                <div className="loading-shading-mui" style={{zIndex: 9999, backgroundColor: 'rgba(249, 249, 249,0.3)'}}>
                    <CircularProgress className="loading-icon-mui"/>
                </div>)
        } else {
            return null
        }
    }

}

export default Loading1;


export const Loading = ({size, zIndex}) => {

    return (
        <div className="loading-shading-mui" style={{zIndex: zIndex || 9999, backgroundColor: 'rgba(249, 249, 249,0.3)'}}>
            <CircularProgress className="loading-icon-mui" size={size || 25} />
        </div>
    )
};


export const LinearLoading = () => (
    <LinearProgress variant="query" color="primary"/>
);